<template>
  <div>
    <div class="check_line">
      <div class="check_line_name">角色权限：</div>
      <div class="check_line_btns" :class=" more ?'btns_box':''">
        <div id="btns_box" v-if="more">
          <div class="check_el_btn" v-for="(item,index) in listData.roleList" :key="index" >
            <el-button @click="roleBtn(item,index,'one')" :type=" ckIndex == index ? 'primary' : '' ">
                {{item.roleName}}
            </el-button>
          </div>
        </div>
        <div class="check_btn_list" v-else>
          <div class="check_el_btn" v-for="(item,index) in listData.roleList" :key="index" >
            <el-button @click="roleBtn(item,index,'one')" :type=" ckIndex == index ? 'primary' : '' ">
                {{item.roleName}}
            </el-button>
          </div>
        </div>
      </div>
      <div class="check_line_more" v-if="showMoreBtn">
        <el-button v-if="more"  @click="clickMore('open')">更多</el-button>
        <el-button v-else  @click="clickMore('close')">收起</el-button>
      </div>
    </div>
    <div class="check_line" v-if="listData.stationList&&listData.stationList.length>0">
      <div class="check_line_name">岗位权限：</div>
      <div class="check_line_btns" :class=" more2 ?'btns_box':''">
        <div id="btns_box2" v-if="more2" >
          <div class="check_el_btn" v-for="(item,index) in listData.stationList" :key="index" >
            <el-button @click="roleBtn(item,index,'two')" :type=" ckIndex2 == index ? 'primary' : '' ">
                {{item.roleName}}
            </el-button>
          </div>
        </div>
        <div class="check_btn_list" v-else>
          <div class="check_el_btn" v-for="(item,index) in listData.stationList" :key="index" >
            <el-button @click="roleBtn(item,index,'two')" :type=" ckIndex2 == index ? 'primary' : '' ">
                {{item.roleName}}
            </el-button>
          </div>
        </div>
      </div>
      <div class="check_line_more" v-if="showMoreBtn2">
        <el-button v-if="more2"  @click="clickMore('open2')">更多</el-button>
        <el-button v-else  @click="clickMore('close2')">收起</el-button>
      </div>
    </div>
    <div class="permission_box">
      <div class="per_box_left">
        <div class="box_left_title">我的应用</div>
        <el-tree class="left_el_tree" v-loading="isShow" element-loading-text="拼命加载中" :data="groupList" :props="defaultProps" @node-click="menuBtn"></el-tree>
        <!-- <el-menu
          default-active="0"
          class="el-menu-vertical-demo"
          @select="handleSelect">
          <el-menu-item :index="index.toString()" v-for="(n,index) in groupList" :key="index" @click="menuBtn(n,index)">
            <span slot="title">{{n.appName}}</span>
          </el-menu-item>
        </el-menu> -->
      </div>
      <div class="per_box_right">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="我的菜单权限" name="first"></el-tab-pane>
          <el-tab-pane label="我的按钮权限" name="second"></el-tab-pane>
        </el-tabs>
        <div>
          <div class="myMenus" v-if="activeName=='first'"  v-loading="isShow2" element-loading-text="拼命加载中">
            <el-tree :data="appMenus" default-expand-all :props="defaultProps" @node-click="handleNodeClick"></el-tree>
          </div>
          <div v-if="activeName=='second'"  v-loading="isShow2" element-loading-text="拼命加载中">
            <el-collapse v-model="activeNames" accordion @change="handleChange">
              <el-collapse-item :title="n.smName" :name="index" v-for="(n,index) in appModules" :key="index">
                <el-table
                  :data="n.features"
                  border
                  :header-cell-style="{background:'#f1f1f1'}"
                  style="width: 100%">
                  <el-table-column
                    label="编码"
                    prop="sfCode">
                  </el-table-column>
                  <el-table-column
                    label="名称"
                    prop="sfName">
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props:{
      listData:{
        type: Object
      },
    },
    data () {
      return {
        ovHeight:true,
        activeNames: [],
        activeName: 'first',
        tableList:[],
        more: true,
        more2: true,
        isShow: true,
        isShow2: true,
        showMoreBtn: false,
        showMoreBtn2: false,
        groupList:[],
        roleId:'',
        appMenus:[],
        appModules:[],
        ckIndex: 0,
        ckIndex2: 0,
      }
    },
    mounted () {
      let vm = this
      setTimeout(()=>{
        vm.roleBtn(vm.listData.roleList[0],0,'one')
        vm.setHeight()
      },1500)
    },
    watch: {
      roleList () {
        this.getWatch()
      }
    },
    methods:{
      handleOpen(key, keyPath) {
      },
      handleClose(key, keyPath) {
      },
      handleSelect(key, keyPath) {
      },
      handleClick(val) {
      },
      handleChange(val) {
      },
      roleBtn(item,index,num){
        let vm = this
        if(num == 'one'){
          let seHeight = $('#btns_box')[0].offsetHeight
          vm.ckIndex = index
          vm.ckIndex2 = -1
          vm.roleId = item.id
          // if(vm.more){
          // }
        }else{
          if( vm.listData.stationList && vm.listData.stationList.length>0 ){
            let seHeight2 = $('#btns_box2')[0].offsetHeight
            vm.ckIndex2 = index
            vm.ckIndex = -1
            vm.roleId = item.id
          }
        }
        vm.isShow = true
        http.get(InterfacePrefix['platform']+'/user/authority/'+item.userId+'/role/'+item.id).then(xhr=>{
          _.each(xhr.data.data,xd=>{
            xd.label = xd.appName
          })
          vm.groupList = xhr.data.data
          vm.isShow = false
          vm.menuBtn(vm.groupList[0],0)
        })
      },
      setHeight(){
        let vm = this
        let seHeight = $('#btns_box')[0].offsetHeight
        if (seHeight > 36) {
          vm.showMoreBtn = true;
        } else {
          vm.showMoreBtn = false;
        }
        if (seHeight2 > 36) {
          vm.showMoreBtn2 = true;
        } else {
          vm.showMoreBtn2 = false;
        }
      },
      moreBtn() {
        let vm = this;
        _.each(vm.listData.roleList,lr=>{
          vm.roleBtn(lr,0)
        })
      },
      clickMore(item) {
        let vm = this;
        if (item == "open") {
          vm.more = false;
        }
        if (item == "close") {
          vm.more = true;
        }
      },
      getWatch(){
        let vm = this
      },
      menuBtn(val){
        let vm = this
        vm.isShow2 = true
        if(vm.$store.state.userInfo.id || item.id || vm.roleId){
          http.get(InterfacePrefix['platform']+'/user/authority/app/param?userId='+vm.$store.state.userInfo.id+'&appId='+val.id+'&roleId='+vm.roleId).then(xhr=>{
            vm.appMenus = xhr.data.data.menus
            vm.appModules = xhr.data.data.modules
            _.each(vm.appModules,(n,l)=>{
              vm.activeNames.push(l)
            })
            _.each(vm.appMenus,n=>{
              n.label = n.smName
              vm.menusChild(n.children)
            })
            vm.isShow2 = false
          })
        }
      },
      menusChild(item){
        let vm = this
        _.each(item,n=>{
          n.label = n.smName
          vm.menusChild(n.children)
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .check_line{ position: relative; 
    .check_line_name{ width:80px; height: 36px; line-height: 36px; position:absolute; left: 0; top: 0; }
    .check_line_btns{ height: 36px; padding: 0 65px 0 80px ; position: relative;
      .check_el_btn{ display: inline-block; margin: 0 4px 4px 4px; }
      .check_btn_list{ position: absolute; top: 0; left: 80px; right: 65px; z-index: 101; background: #fff; border-bottom: 1px solid #e5e7ea;
        .check_el_btn{ display: inline-block; margin: 0 4px 4px 4px ; }
      }
    }
    .btns_box{ height: 36px; overflow: hidden;}
    .check_line_more{ position: absolute; text-align: right; right: 0; top: 0; width: 80px; z-index: 101; }
  }
  .permission_box{ margin-top: 16px; position: relative;
    .per_box_left{ position:absolute; width: 200px; min-height: 200px; height: 100%; 
      .box_left_title{ border: 1px solid #e5e7ea; border-bottom: none; padding: 0 8px; box-sizing: border-box; height: 40px; 
        line-height: 40px; font-size: 16px; font-weight: 700; color: #333; }
      .left_el_tree{ border: 1px solid #e5e7ea; min-height: 200px; padding: 8px 0; box-sizing: border-box; }
    }
    .per_box_right{ margin-left: 216px ; border: 1px solid #e5e7ea; min-height: 400px; padding: 16px; box-sizing: border-box; }
    &::after{ content: ''; display: block; clear: both; }
  }
</style>
<style>
  .myMenus>.el-tree .el-tree-node .el-tree-node__content .el-tree-node__expand-icon{ padding: 0 ; margin-top: 3px; }
</style>








// WEBPACK FOOTER //
// src/components/setting/basic_information/permission/function.vue